import { Action } from '@ngrx/store';
import {PlanMgt} from '../plan.model';

export enum PlanMgtActionTypes {
  LoadPlanMgts = '[PlanMgt] Load PlanMgts',
  GetPlanMgts = '[PlanMgt] Get PlanMgts',
  GetPlanMgtsFail = '[PlanMgt] Get PlanMgts Fail',
  GetUpdatePlanMgts = '[PlanMgt] Get Update PlanMgts'
}

export class LoadPlanMgts implements Action {
  readonly type = PlanMgtActionTypes.LoadPlanMgts;
  constructor(public payload: PlanMgt[]) {}
}

export class GetPlanMgts implements Action {
  readonly type = PlanMgtActionTypes.GetPlanMgts;
  constructor(public payload: any = null) {}
}

export class GetPlanMgtsFail implements Action {
  readonly type = PlanMgtActionTypes.GetPlanMgtsFail;
}

export class GetUpdatePlanMgts implements Action {
  readonly type = PlanMgtActionTypes.GetUpdatePlanMgts;
  constructor(public payload: PlanMgt[]) {}
}


export type PlanMgtActions = LoadPlanMgts
  | GetPlanMgts
  | GetPlanMgtsFail
  | GetUpdatePlanMgts;
